import React, { useEffect } from 'react';
import Bracket from '../new-game-inputs/Bracket';
import Rounds from '../new-game-inputs/Rounds';
import Rules from '../new-game-inputs/Rules';
import Rewards from '../new-game-inputs/Rewards';
import Incentive from '../new-game-inputs/Incentive/Incentive.container';
import NewGameState from '../_types/NewGameState';

type Props = {
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
  setShouldDisableNextOrFinishButton: (should: boolean) => void;
  scrollToTop?: () => void;
};

const Step2: React.FC<Props> = ({
  newGameState,
  onChangeNewGameState,
  setShouldDisableNextOrFinishButton,
  scrollToTop,
}) => {
  // Sync bracketName and KPIRuleID from rounds data to ensure validation passes
  useEffect(() => {
    if (newGameState.contestType === 'bracket_manual') {
      if (newGameState.bracket?.roundValues?.length > 0) {
        // Get values from rounds
        const firstRound = newGameState.bracket.roundValues[0];
        const lastRoundIndex = newGameState.totalRounds
          ? newGameState.totalRounds - 1
          : 0;
        const lastRound = newGameState.bracket.roundValues[lastRoundIndex];

        const needsUpdate =
          (firstRound?.bracketName && !newGameState.bracketName) ||
          (lastRound?.KPIRuleID && !newGameState.KPIRuleID);

        if (needsUpdate) {
          console.log(
            '[BRACKET-STEP2] Syncing values from rounds to parent state',
            {
              bracketName: firstRound?.bracketName || newGameState.bracketName,
              KPIRuleID: lastRound?.KPIRuleID || newGameState.KPIRuleID,
            }
          );

          onChangeNewGameState({
            ...newGameState,
            bracketName: firstRound?.bracketName || newGameState.bracketName,
            KPIRuleID: lastRound?.KPIRuleID || newGameState.KPIRuleID,
          });
        }
      }
    }
  }, [newGameState.bracket?.roundValues]);

  const renderBracketView = () => (
    <>
      <Bracket
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
      />
      <Rounds
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
        setShouldDisableNextOrFinishButton={setShouldDisableNextOrFinishButton}
        scrollToTop={scrollToTop}
      />
    </>
  );

  const renderStandardView = () => (
    <>
      <Rules
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
      />
      <Rewards
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
      />
    </>
  );

  if (newGameState.contestType === 'bracket_manual') {
    return renderBracketView();
  }

  if (newGameState.contestType === 'incentive') {
    return (
      <>
        <Incentive
          newGameState={newGameState}
          onChangeNewGameState={onChangeNewGameState}
        />
        <Rewards
          newGameState={newGameState}
          onChangeNewGameState={onChangeNewGameState}
        />
      </>
    );
  }

  return renderStandardView();
};

export default Step2;
